import Vue from 'vue';
import 'lazysizes';
import { init } from '@changba/funny'

import {
  Swipe,
  SwipeItem,
  ActionSheet,
  Popup,
  Picker,
  Toast,
  Dialog,
  Switch,
  CountDown,
  Icon,
  Rate,
  List,
  RadioGroup,
  Radio,
  PullRefresh,
  Tab,
  Tabs,
  Sku,
  Empty,
  Checkbox,
  NoticeBar,
  Overlay
} from 'vant';

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(ActionSheet);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Switch);
Vue.use(CountDown);
Vue.use(Icon);
Vue.use(Rate);
Vue.use(List);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(PullRefresh);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Sku);
Vue.use(Empty);
Vue.use(Checkbox);
Vue.use(NoticeBar);
Vue.use(Overlay);


import 'vant/lib/icon/local.css';

Toast.setDefaultOptions('loading', { forbidClick: true, duration: 0 });

import '@cdn_css/index.scss';

import App from './App.vue';
import router from './router';

import cbs from './changba-stats';

Vue.use(cbs);

import '@module/helper/init';

window.setShareUrlParams = () => JSON.stringify({
  title: '唱吧人工修音',
  content: '原创歌曲购买-音乐教学-人工修音-全网发行',
  imageurl: 'https://res.cdn.changbaimg.com/!/share-image/logo_300x300.png',
  thumburl: 'https://res.cdn.changbaimg.com/!/share-image/logo_300x300.png',
  targeturl: 'https://changba.com/njwap/chanpin/mall/index/main/homes/post-production'
});

window.__changbaPageHideCallback = () => {
  const nodes = document.querySelectorAll('audio');

  nodes.forEach((item) => {
    item.pause();
  });
};

Vue.config.productionTip = false;

import commonObj from 'commonObj';
import localStorage from './local-storage';
import qs from 'qs';
import initializeBrowserLogger from '@module/helper/browser-logger';
import getGlobalParams from '@module/helper/changba-global-params';

Vue.prototype.$isChangbaTester = false;
const callChangba = commonObj.utils.getQueryStrFn('call_changba');
const backMusicboard = commonObj.utils.getQueryStrFn('back_musicboard');

if (backMusicboard === 'yes') {
  localStorage.setItem('changba-music-mall-float-navigator', 'musicboard');
}
else if (backMusicboard === 'no') {
  localStorage.setItem('changba-music-mall-float-navigator', 'default');
}

const bootstrap = async () => {
  await initializeBrowserLogger({ projectName: '人工修音' });
  const globalParams = await getGlobalParams();

  Vue.prototype.$globalParams = globalParams;
  Vue.prototype.$curuserid = globalParams.userId;
  Vue.prototype.$token = globalParams.token;
  Vue.prototype.$macaddress = globalParams.macaddress;
  // 兼容
  commonObj.data.userid = globalParams.userId;
  commonObj.data.token = globalParams.token;

  if (commonObj.data.outChangbaNew && callChangba === 'yes') {
    const url = window.location.href.split('?');
    const query = qs.parse(url[1]);
    query.call_changba = undefined;
    commonObj.utils.openApp(false, `${url[0]}?${qs.stringify(query)}`);
  }
  else {
    init()
    new Vue({
      router,
      render: h => h(App)
    }).$mount('#app');
  }
};

bootstrap();
